import React from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import {
  Body,
  Cell,
  Header,
  HeaderCell,
  HeaderRow,
  Row,
  Table
} from '@table-library/react-table-library/table';
import { useTheme } from '@table-library/react-table-library/theme';
import { Chip, Button } from '@material-tailwind/react';
import { Pagination } from '@/shared/components/pagination'
import { usePagination } from '@table-library/react-table-library/pagination'
import { useSearchParams, Link } from 'react-router-dom'

const GroupList = ({ groups = [], meta = {}, onEdit, onDelete }) => {
  const nodes = { nodes: groups };
  
  const theme = useTheme({
    Table: `
      --data-table-library_grid-template-columns: 1.5fr 4fr 1fr 1fr;
      font-size: 14px;
      font-family: inherit;
    `,
    BaseCell: `
      padding: 0.75rem;
      color: #1f2937;
    `,
    HeaderCell: `
      background-color: #f3f4f6;
      font-weight: 600;
      color: #374151;
    `,
  });

  const [searchParams, setSearchParams] = useSearchParams()
  
  const currentPage = Number(searchParams.get('page')) || 1;
  const initialPage = Math.max(currentPage - 1, 0);

  const onPaginationChange = (action, state) => {
    const newPage = state.page + 1;
    searchParams.set('page', newPage);
    searchParams.set('per_page', state.size);
    setSearchParams(searchParams);
  };

  const pagination = usePagination(
    nodes,
    {
      state: {
        page: initialPage,
        size: Number(searchParams.get('per_page')) || 10
      },
      onChange: onPaginationChange
    },
    {
      isServer: true
    }
  )

  return (
    <div className='flex flex-col justify-between gap-4 h-full'>
    <Table 
        data={nodes} 
        theme={theme}
        className="w-full"
        layout={{ custom: true }}
      >
        {(tableList) => (
          <>
            <Header>
              <HeaderRow>
                <HeaderCell>Nombre</HeaderCell>
                <HeaderCell>Descripción</HeaderCell>
                <HeaderCell>Estado</HeaderCell>
                <HeaderCell>Acciones</HeaderCell>
              </HeaderRow>
            </Header>

            <Body>
              {tableList.map((group) => (
                <Row key={group.id} item={group}>
                  <Cell className="font-medium">{group.name}</Cell>
                  <Cell className="text-gray-600">{group.description || '-'}</Cell>
                  <Cell>
                    <Chip
                      variant="ghost"
                      color={group.active ? 'green' : 'red'}
                      size="sm"
                      className="capitalize w-fit"
                      value={group.active ? 'Activo' : 'Inactivo'}
                    />
                  </Cell>
                  <Cell>
                    <div className="flex gap-2">
                      <button 
                        onClick={() => onEdit(group)}
                        className="text-gray-600 hover:text-gray-700 transition-colors"
                      >
                        <FiEdit2 className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => onDelete(group.id)}
                        className="text-gray-600 hover:text-gray-700 transition-colors"
                      >
                        <FiTrash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </Cell>
                </Row>
              ))}
              
              {groups.length === 0 && (
                <Row>
                  <Cell colSpan={4} className="text-center py-6 text-gray-500">
                    No hay grupos disponibles
                  </Cell>
                </Row>
              )}
            </Body>
          </>
        )}
      </Table>
      <div className="flex justify-between items-center gap-4">
        <div className="flex-1"></div>
        
        <Pagination
          onPageChange={({ selected }) => pagination.fns.onSetPage(selected)}
          page={pagination.state.page}
          totalPage={meta?.pagination?.total_pages || 1}
        />
        
        <div className="flex-1 flex justify-end">
          <Link to="/users?page=1&per_page=10">
            <Button 
              variant="outlined" 
              className="bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
            >
              Volver
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GroupList;